import { useTranslation } from 'react-i18next';
import { Badge } from './ui.tsx';

/**
 * Etiqueta do administrador master (ADR 0051/0052). A marca não vira perfil gravado, então sem a
 * etiqueta a pessoa não teria como saber que é master. Só mostra: nenhuma tela muda a marca.
 */
export function MasterBadge() {
  const { t } = useTranslation();
  return (
    <span title={t('users.masterHelp')}>
      <Badge tone="accent">{t('users.master')}</Badge>
    </span>
  );
}
